var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSavingsPlan = function SvgSavingsPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#237803"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 19.135a3.135 3.135 0 1 1 6.27 0 3.135 3.135 0 0 1-6.27 0Zm3.135-1.635a1.635 1.635 0 1 0 0 3.27 1.635 1.635 0 0 0 0-3.27Zm13.645-1.28a.75.75 0 0 1 0 1.06l-15.5 15.5a.75.75 0 1 1-1.06-1.06l15.5-15.5a.75.75 0 0 1 1.06 0Zm-6.05 13.645a3.135 3.135 0 1 1 6.27 0 3.135 3.135 0 0 1-6.27 0Zm3.135-1.634a1.635 1.635 0 1 0 0 3.269 1.635 1.635 0 0 0 0-3.27Z",
    fill: "#fff"
  })));
};
export default SvgSavingsPlan;